<template>
  <div class="map-drag">
    <headerBack :backParams="backParams" @backBtn="back"></headerBack>
    <div class="search-wrapper">
      <div class="search-left">
        <div class="station start-station">
          <div class="circle start-circle"></div>
          <div class="station-name has-station">{{startStation.name}}</div>
        </div>
        <div class="station">
          <div class="circle end-circle"></div>
          <div class="station-name has-station">{{endStation.name}}</div>
        </div>
      </div>
      <div class="search-right" @click="changeStation">
        <div class="iconfont icon-zhuanhuan"></div>
      </div>
    </div>
    <div class="tab-wrapper">
      <div class="tab-item" :class="{'active': transferPolicyStr === item.value}" v-for="(item, index) in list" :key="index" @click="tabItem(item)">
        {{item.name}}
      </div>
    </div>
    <div id="container"></div>
    <div class="line-list">
      <div id="routeInfo" ref="panel"></div>
    </div>
  </div>
</template>
<script>
// 地图选点
import wx from 'weixin-js-sdk'
import { mapGetters } from 'vuex'
import headerBack from '@/components/headerBack'
import AMap from 'AMap'
import AMapUI from 'AMapUI'
export default {
  name: 'mapLine',
  components: {headerBack, AMap, AMapUI},
  data () {
    return {
      backParams: {
        title: '线路详情'
      },
      latAndLng: {},
      stationObj: {},
      startStation: {},
      endStation: {},
      map: null, // 高德地图
      transferPolicyStr: 5,
      list: [{name: '最经济模式', value: 5}, {name: '最快捷模式', value: 0}, {name: '最少换乘模式', value: 2}]
    }
  },
  computed: {
    ...mapGetters([])
  },
  mounted () {
    this.getLatAndLng()
    this.stationObj = this.$session.getLocalStorage('mapLineStation') || this.$route.params.backSearchObj
    this.startStation = this.stationObj.startStation
    this.endStation = this.stationObj.endStation
    this.initMap()
    this.$wxHide()
  },
  methods: {
    back () {
      this.$router.push({name: 'transfer'})
    },
    getLatAndLng () {
      let latAndLng = this.$session.getLocalStorage('latAndLng') || {}
      if (latAndLng  && latAndLng.lat && latAndLng.lng) {
        this.latAndLng = latAndLng
      } else {
        wx.ready(() => { // 需在用户可能点击分享按钮前就先调用
          wx.getLocation({
            type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: (res) => {
              const position = {
                lat: res.latitude,
                lng: res.longitude
              }
              this.latAndLng = position
              this.$session.setLocalStorage('latAndLng', position)
            }
          })
        })
      }
    },
    changeStation () {
      const cicheObj = this.startStation
      this.startStation = this.endStation
      this.startStation.type = 'start'
      this.endStation = cicheObj
      this.endStation.type = 'end'
      // 销毁地图和清空元素
      this.map.destroy()
      this.$refs.panel.innerHTML = ''
      // 重新拉去地图数据
      this.initMap()
    },
    // 初始化地图 并且定位+搜索+选点
    initMap () {
      this.map = new AMap.Map('container', {
        resizeEnable: true,
        zoom: 14 // 地图显示的缩放级别
      })
      this.busList()
    },
    // 公交出行路线
    busList () {
      AMap.plugin(['AMap.ToolBar', 'AMap.Scale', 'AMap.ControlBar', 'AMap.Geolocation', 'AMap.Transfer'], () => {
        // this.map.addControl(new AMap.ToolBar())
        // this.map.addControl(new AMap.Scale())
        // this.map.addControl(new AMap.ControlBar())
        this.map.addControl(new AMap.Geolocation())
        const TransferOptions = {
          city: this.$cityCode.city, // 公交换乘的城市，支持城市名称、城市区号、电话区号，此项为必填
          policy: this.transferPolicyStr, // 公交换乘策略 TransferPolicy 对象
          nightflag: false, // 是否计算夜班车，默认为不计算 true：计算，false：不计算
          extensions: 'all', // 返回结果控制可选值：base/all base:返回基本信息 all:返回全部信息 默认值 ：base
          map: this.map, // AMap.Map对象, 展现结果的地图实例。当指定此参数后，搜索结果的标注、线路等均会自动添加到此地图上。可选参数
          panel: 'routeInfo', // 结果列表的HTML容器id或容器元素，提供此参数后，结果列表将在此容器中进行展示。可选参数
          hideMarkers: false, // 设置隐藏路径规划的起始点图标，设置为true：隐藏图标；设置false：显示图标 默认值为：false
          autoFitView: true // 用于控制在路径规划结束后，是否自动调整地图视野使绘制的路线处于视口的可见范围
        }
        // 构造公交换乘类
        let transfer = new AMap.Transfer(TransferOptions)
        // 根据起、终点坐标查询公交换乘路线,使用父组件传入的起终点经纬度
        transfer.search(new AMap.LngLat(this.startStation.lng, this.startStation.lat), new AMap.LngLat(this.endStation.lng, this.endStation.lat))
        // 返回出行方式信息
        AMap.event.addListener(transfer, 'complete', (res) => {
          // console.log('complete', res)
        })
        // 返回出行方式信息出错信息
        AMap.event.addListener(transfer, 'error', (err) => {
          console.log(err)
        })
      })
    },
    tabItem (item) {
      this.transferPolicyStr = item.value
      // 销毁地图和清空元素
      this.map.destroy()
      this.$refs.panel.innerHTML = ''
      // 重新拉去地图数据
      this.initMap()
    }
  }
}
</script>
<style lang="scss" scoped>
.map-drag {
  width: 100%;
  height: 100%;
  overflow: auto;
  .search-wrapper {
    width: auto;
    height: 0.8rem;
    display: flex;
    align-items: center;
    background: #ffffff;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    .search-left {
      flex: 1 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 0.2rem;
      .station {
        width: 100%;
        height: 0.39rem;
        background: #ffffff;
        display: flex;
        align-items: center;
        &.start-station {
          border-bottom: 1px solid #eeeeee;
        }
        .circle {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          overflow: hidden;
          &.start-circle {
            background: #16a951;
          }
          &.end-circle {
            background: #f00056;
          }
        }
        .station-name {
          flex: 1 auto;
          padding: 0rem 0.1rem;
          font-size: 16px;
          &.has-station {
            color: #000000;
            font-weight: 800;
          }
          &.no-station {
            color: #999999;
          }
        }
        .iconfont {
          font-size: 12px;
        }
      }
    }
    .search-right {
      width: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      .iconfont {
        font-size: 24px;
        background: #ffffff;
        padding: 5px;
        border-radius: 50%;
      }
    }
  }
  .tab-wrapper {
    width: 100%;
    height: 20px;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 16px;
    border-bottom: 1px solid #eeeeee;
    .tab-item {
      display: flex;
      justify-content: center;
      flex: 1 auto;
      border-right: 1px solid #1989fa;
      &.tab-item:last-child {
        border-right: none;
      }
      &.active {
        color: #1989fa;
      }
    }
  }
  #container {
    width: 100%;
    height: 350px;
  }
  #routeInfo {
    width: 100%;
    height: 300px;
  }
}
::v-deep {
  .amap-call{
    display: none !important;
  }
}
</style>
